import { Outlet } from "react-router-dom";
import { Typography } from "@/components/atoms";
import { Tabs } from "@/components/molecules";
import { useClientScope } from "@/components/pages/Client/settings/ClientScopeContext";

const favouriteTabs = [
  { name: "Locations", to: "locations" },
  { name: "Guest Passengers", to: "guests" },
  { name: "Drivers", to: "drivers" },
];

/**
 * Client-portal Manage-Client Favourites tab — mirrors the operator precedent
 * (`Clients/ManageClient/favourites/ManageClientFavourites`) but does NOT wrap its own
 * `ClientScopeProvider`: the takeover shell already scopes the body `<Outlet/>` to the managed
 * account, so the reused favourites tables (FavouriteLocations / FavouriteGuests / FavouriteDrivers)
 * read the account id from `useClientScope()` automatically.
 */
export const ManageClientFavourites = () => {
  const { isViewOnly } = useClientScope();

  return (
    <div className="flex flex-1 flex-col">
      {/* Self-cap at 1164 (mirrors the standalone ClientFavourites, DEV-1366) — narrower than the
          takeover's 2360 body shell; a no-op below the cap (DEV-1367). */}
      <div className="mx-auto w-full max-w-[1164px] px-3 pb-12 pt-4 lg:px-5">
        <Typography variant="h2" className="mb-3 block">
          Favourites
        </Typography>

        <Tabs className="no-scrollbar min-w-0 border-b !border-neutral-mid-gray" tabs={favouriteTabs} mobileVariant="sheet" />

        {/* relative anchors the per-table "Add …" buttons (absolute -top-12 right-0); mt-3 (matching
            the client ClientFavourites shell) floats them up onto the tab row, as in the Figma.
            View-only access (removed EA, parity with operator DEV-1177) disables add/edit controls. */}
        <fieldset disabled={isViewOnly} className="relative mt-3">
          <Outlet />
        </fieldset>
      </div>
    </div>
  );
};
